import { render, staticRenderFns } from "./UserAddressForm.vue?vue&type=template&id=d61f2158&"
import script from "./UserAddressForm.vue?vue&type=script&lang=js&"
export * from "./UserAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports